import { base62ToHex, hexToBase62, } from '@streamr/tv-engine';
import { toStreamID, toUserId } from '@streamr/utils';
import { matchPath } from 'react-router';
export function formBroadcastPath(broadcast, basePath = '/stream') {
    return (`${basePath}/${broadcast.streamId}` +
        `?title=${encodeURIComponent(broadcast.name)}` +
        `&broadcasterUserId=${hexToBase62(broadcast.broadcasterUserId)}` +
        `&startTime=${broadcast.startsAt}` +
        `#aesKey=${hexToBase62(broadcast.aesKey)}`);
}
export function formBroadcastUrl(broadcast, basePath = '/stream') {
    return formPageUrl(formBroadcastPath(broadcast, basePath));
}
export function parseBroadcastFromUrl(url) {
    if (url.pathname === '/')
        return parseBroadcastFromLegacyUrl(url);
    const match = matchPath('/stream/:streamId', url.pathname) ??
        matchPath('/recordings/:streamId', url.pathname) ??
        matchPath('/embed/:streamId', url.pathname);
    if (match?.params.streamId !== undefined) {
        const streamId = toStreamID(match.params.streamId);
        const hashParams = new URLSearchParams(url.hash.replace(/^#/, ''));
        const name = url.searchParams.get('title'); // TODO the name and title refer to same thing, which is the preferred term?
        const startsAtAsString = url.searchParams.get('startTime');
        const encodedBroadcasterUserId = url.searchParams.get('broadcasterUserId');
        const encodedAesKey = hashParams.get('aesKey');
        if (name == null ||
            startsAtAsString === null ||
            encodedBroadcasterUserId === null ||
            encodedAesKey === null) {
            throw new Error('Invalid url');
        }
        const aesKey = base62ToHex(encodedAesKey, false);
        const broadcasterUserId = toUserId(base62ToHex(encodedBroadcasterUserId, true));
        return {
            streamId,
            name,
            startsAt: Number(startsAtAsString),
            broadcasterUserId,
            aesKey,
        };
    }
    return undefined;
}
// TODO remove within few months
function parseBroadcastFromLegacyUrl(url) {
    if (url.hash === '')
        return undefined;
    const [path, query] = url.hash.slice(1).split('?');
    const match = matchPath('/stream/:streamId', path) ??
        matchPath('/embed/:streamId', path);
    if (match?.params.streamId !== undefined) {
        const streamId = toStreamID(match.params.streamId);
        const queryParams = new URLSearchParams(query);
        const name = queryParams.get('title'); // TODO the name and title refer to same thing, which is the preferred term?
        const startsAtAsString = queryParams.get('startTime');
        // temporary migration for legacy "publicKey" property name (FRONT-2247), TODO remove within few months
        const encodedBroadcasterUserId = queryParams.get('broadcasterUserId') ??
            queryParams.get('publicKey');
        const encodedAesKey = queryParams.get('aesKey');
        if (name == null ||
            startsAtAsString === null ||
            encodedBroadcasterUserId === null ||
            encodedAesKey === null) {
            throw new Error('Invalid url');
        }
        const aesKey = base62ToHex(encodedAesKey, false);
        const broadcasterUserId = toUserId(base62ToHex(encodedBroadcasterUserId, true));
        return {
            streamId,
            name,
            startsAt: Number(startsAtAsString),
            broadcasterUserId,
            aesKey,
        };
    }
    return undefined;
}
export function formPageUrl(path) {
    const url = new URL(path, window.location.toString());
    return url.toString();
}
export function generateStreamId() {
    return `${Math.random().toString(36).substring(2)}`;
}
